module.exports = __webpack_public_path__ + "img/woman-leg-front.479bf41a.png";